import React from "react";
import NodataFound from "../../../../commons/Toast/noDataFound";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import "./bankingSearch.css";
import { getBankingSearch } from "../../../../store/Banking/actions";
import { BankingSlot } from "../bankingSlot";
import documentUploadService from "../../../../components/Services/documentUpload.service";
import BankViewModal from "../BankViewModal/BankViewModal";

const BankingSearch = () => {
  const role = useSelector((state) => state?.sessionState?.role);
  const bankingList = useSelector(
    (state) => state?.bankingCapacityReducer?.allBankingSearch
  );

  const dispatch = useDispatch();

  const [empty, setEmpty] = useState(false);
  const [isModel, setIsModel] = useState(false);
  const [docData, setDocData] = useState(null);
  const [directConnect, setDirectConnect] = useState(false);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [viewData, setViewData] = useState({});

  useEffect(() => {
    getBankingSearch()(dispatch);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (bankingList?.length == 0) {
        setEmpty(true);
      }
    }, 2000);
  }, []);

  const getDocDataById = (id) => {
    documentUploadService
      .getDocumentById(id)
      .then((response) => {
        if (response?.data?.code === 200) {
          setDocData(response?.data?.data);
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };

  const handleEditClick = (item, directConn) => {
    setDirectConnect(directConn ? true : false);
    setIsModel(item);
    item?.tenderDocumentId && getDocDataById(item?.tenderDocumentId);
  };

  const handleShowDetails = (data) => {
    setViewData(data);
    setTimeout(() => {
      setViewMoreModal(true);
    }, 1000);
  };

  return (
    <>
      {viewMoreModal && (
        <BankViewModal
          open={viewMoreModal}
          handleClose={() => setViewMoreModal(false)}
          data={viewData}
        />
      )}
      {isModel && (
        <BankingSlot
          isOpen={isModel}
          docData={docData}
          handleSubmit={handleEditClick}
          isDirectConnect={directConnect}
        />
      )}
      <div
        className="card-box-search-banking"
        style={{ display: "flex", flexDirection: "row" }}
      >
        <div className="card-box-capacities p-4" id="capacityListingNew">
          {!empty ? (
            bankingList?.map((item, i) => (
              <div key={i} className="mb-4 ">
                <div className="eachListContainer">
                  <div className="listingContent">
                    <div className="eachDetailCont">
                      <div>{item?.name}</div>
                      <div className="expiresText">
                        <span>Expires On:- </span>
                        {item?.expiryAt
                          ?.split(" ")?.[0]
                          ?.split("-")
                          ?.join(" ")}{" "}
                        - {item?.expiryAt?.split(" ")?.[1]}
                      </div>
                    </div>
                    <div className="eachDetailCont">
                      <div>Injection Drawal Range</div>
                      <div
                        style={{ color: "#ff7d00", cursor: "pointer" }}
                        onClick={() => handleShowDetails(item)}
                      >
                        View Details
                      </div>
                    </div>
                    <div className="eachDetailCont">
                      <div>Region</div>
                      <div>{item?.company?.region || "NA"}</div>
                    </div>
                    <div className="eachDetailCont">
                      <div>State</div>
                      <div>{item?.company?.state || "NA"}</div>
                    </div>
                    <div className="eachDetailCont">
                      <div>Credit Rating</div>
                      <div>{item?.company?.creditRating}</div>
                    </div>
                    <div className="eachDetailCont">
                      <div>Quantity (MW)</div>
                      <div>{item?.requiredQty}</div>
                    </div>
                    <div className="eachDetailCont">
                      <div>Banking Factor</div>
                      <div>{item?.bankingFactor}</div>
                    </div>
                  </div>
                  <div
                    className="connectButtonCont"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditClick(item, true);
                    }}
                  >
                    {" "}
                    Connect
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div style={{ marginTop: "200px" }}>
              <NodataFound />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BankingSearch;
